import { render, staticRenderFns } from "./game_words.vue?vue&type=template&id=40a5b010&"
import script from "./game_words.vue?vue&type=script&lang=js&"
export * from "./game_words.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports